import { H1 } from '@payaca/ambrosia';
import { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import CreateServicePlanControl from '@/ui/components/createServicePlanControl/CreateServicePlanControl';
import ManageServicePlanControl from '@/ui/components/manageServicePlanControl/ManageServicePlanControl';
import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';

import * as servicePlansActions from '@payaca/store/servicePlans/servicePlansActions';

import { useServicePlan } from '@payaca/store/hooks/appState';

import { useTranslation } from '../../../i18n';

import './ServicePlanPage.sass';

const ServicePlanPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const params: { servicePlanId: string } = useParams();
  const translate = useTranslation();

  const servicePlanId = useMemo(
    () => (params.servicePlanId !== 'new' ? params.servicePlanId : undefined),
    [params]
  );
  const servicePlan = useServicePlan(servicePlanId);

  useEffect(() => {
    if (servicePlanId) {
      dispatch(
        servicePlansActions.getServicePlan.request({
          publicId: servicePlanId,
        })
      );
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'dispatch'
  }, [servicePlanId]);

  return (
    <>
      <Helmet
        title={translate('pages.servicePlan.title', {
          name: servicePlan?.name || '',
        })}
      />
      <AuthenticatedPageWrapper
        className="service-plan-page"
        breadcrumbItems={[
          { label: 'Back', to: '/service-plans/listed-plans' },
          { label: 'Service plan' },
        ]}
      >
        {!servicePlanId && (
          <div className="px-8 py-4">
            <H1>New service plan</H1>
          </div>
        )}
        <div className="p-4">
          {!servicePlanId && (
            <CreateServicePlanControl
              onCreateSuccess={() =>
                history.push('/service-plans/listed-plans')
              }
            />
          )}
          {servicePlanId && (
            <ManageServicePlanControl servicePlanId={servicePlanId} />
          )}
        </div>
      </AuthenticatedPageWrapper>
    </>
  );
};

export default ServicePlanPage;
